import React, {useState, useEffect, useRef /*, useContext */ } from 'react';
import { Button, Drawer, Form, Input, Select, Divider, Space, message } from 'antd';
import { FolderAddOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { api } from '../AppConfig';
import * as Setting from '../utils/AuthUtils';
import { useTranslation } from 'react-i18next';

function AddDecklist(props) {
    const { t } = useTranslation();
    // const [archetypes, setArchetypes] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isActive, setIsActive] = useState(false)
    const [form] = Form.useForm();
    const [selected, setSelected] = useState([]);
    const [selectedDeck, setSelectedDeck] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();

    function toggleDrawer() {
        if (isActive) {
            form.resetFields();
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }


    function onFinish(values) {
        setIsLoading(true)
        const deckSave = {}
        deckSave.playerId = props.player.playerId.toString();
        deckSave.deckName = values.deckName;
        deckSave.TxtDeckList = values.TxtDeckList;
        // we need to pass the eventId in int format, converting from string to int
        deckSave.stageId = parseInt(props.id);
        if (props.isTournament) {
            // console.warn('is a tournament')
            deckSave.isTournament = true
        } else {
            // console.warn('is a stage')
            deckSave.isTournament = false;
        }
        props.addDecklist.mutate(deckSave);
        setIsActive(false);
        form.resetFields();
    }

    /* console.warn('props archetypes in adddecklist', props.archetypes.data.payLoad);
    const decknameOpts = props.archetypes && props.archetypes.length > 0 ? props.archetypes.data.payLoad.map((d) => {
      return (<Select.Option key={d.id} value={d.name}>{d.name}</Select.Option>)
    }) : null; */

    function generateArchetypeOptions() {
        if (props.archetypes && props.archetypes.data && props.archetypes.data.payLoad && props.archetypes.data.payLoad.length > 0) {
            const opts = props.archetypes.data.payLoad.map((d) => {
                return (<Select.Option key={d.id} value={d.name}>{d.name}</Select.Option>)
            })
            // console.warn('opts', opts);
            return opts;
        }
        return null;
    }

    return (
        (<div>
          {contextHolder}
            <Button size="small" type="primary" onClick={toggleDrawer}>
                Add Decklist
            </Button>
            <Drawer 
                title={t('decks.create')} 
                open={isActive} 
                onClose={toggleDrawer} 
                mask={true}
            >
                <Form form={form} onFinish={onFinish} initialValues={{ "name": props.player.playerName + ' ' + props.player.playerSurname, "deckName": props.player.deckName }}>
                    <Form.Item label={t('players.name')} name="name">
                        <Input disabled />
                    </Form.Item>
                    <Form.Item label={t('decks.title')} name="deckName">
                        <Select 
                            placeholder={t('decks.placeholder')}
                            value={selectedDeck}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        >
                            {generateArchetypeOptions()}
                        </Select>
                    </Form.Item>
                    <Form.Item label="Decklist" name="TxtDeckList" tooltip={{ title: 'Inserire la lista in formato txt, nel seguente modo: <nr copie> <nome carta in inglese>', icon: <InfoCircleOutlined /> }}>
                        <Input.TextArea rows={10} placeholder="Decklist" />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 16, span: 8 }}>
                        <Button type="primary" htmlType="submit" style={{ width: '100%'}} loading={isLoading}>
                            Add
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
        </div>)
    );
}

export default AddDecklist;